import CaptableCaptables from './container';

export default CaptableCaptables;
